import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import ChunkLoadingPopover from '../../UserWidgets/_partials/ChunkLoadingPopover';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../../UserWidgets/_partials/WidgetBoxWide';
import reduxConnectContainer from './GroupAbout.container';
import { default as GroupAbout, Props as WidgetProps } from './GroupAbout';

const EditPopup = lazy(
  () => import(/* webpackChunkName: "owner" */ './EditPopup')
);

const GroupAboutBoxWide: React.FC<WidgetProps & WidgetBoxWideProps> = ({
  id,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  section,
  zone,
  parentRef,
  headerExtraElementsOnMobile,
  isHeaderStickyOnMobile,
  ...props
}) => {
  const { t } = useTranslation();
  const renderConfigPopup = close => {
    const { moduleId } = props;
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <EditPopup moduleId={moduleId} onRequestClose={close} />
      </Suspense>
    );
  };

  return (
    <WidgetBoxWide
      section={section}
      zone={zone}
      moduleId={props.moduleId}
      id={id}
      header={props.title || t('widgets.group_about.header')}
      headerExtraElementsOnMobile={headerExtraElementsOnMobile}
      isHeaderStickyOnMobile={isHeaderStickyOnMobile}
      parentRef={parentRef}
      widgetMenuRenderer={renderConfigPopup}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
    >
      <GroupAbout {...props} />
    </WidgetBoxWide>
  );
};

export default reduxConnectContainer(GroupAboutBoxWide);
